import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RoutingHelperService} from '../../services/routing-helper.service';
import {CareServiceComponent} from './components/care-service/care-service.component';

const fieldNames = ['id', 'urlPath', 'careServiceId', 'careServiceUrlPath'];

const routes: Routes = [
  {
    matcher: (url) => {
      const posParams = RoutingHelperService.CreatePosParams(fieldNames, url);
      return posParams ? {consumed: url, posParams} : null;
    },
    component: CareServiceComponent,
    data: {layout: {narrowMainContainer: true, greyBackground: true}},
  },
  {
    path: '**',
    component: CareServiceComponent,
    data: {layout: {narrowMainContainer: true, greyBackground: true}},
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CareServiceRoutingModule {}

export const careserviceRoutingComponents = [CareServiceComponent];
